export const YEARS = [
  { label: "2026", value: "2026" },
  { label: "2025", value: "2025" },
];
export const DEFAULT_MONTH = "Mar";
export const DEFAULT_YEAR = "2026";

export const formatValue = (value) => Number(value || 0).toFixed(2);

export const formatDashboardTitle = (name) =>
  name
    ?.toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase()) || "Dashboard Detail";

export const getConsolidatedReportLink = (dashboard) => {
  const files = dashboard?.Main_EDA_Files;
  if (!Array.isArray(files) || !files.length) return null;

  const match =
    files.find((f) =>
      (f?.id || f?.TableName || "").toLowerCase().includes("consolidated"),
    ) || files[0];

  return match?.xlsLink || match?.csvLink || null;
};

export const MONTH_ORDER = {
  Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
  Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
};

export const parseMonthYear = (monthYear) => {
  if (!monthYear) return -Infinity;
  const [mon, year] = monthYear.split("_");
  const monthIndex = MONTH_ORDER[mon] ?? 0;
  return Number(year || 0) * 12 + monthIndex;
};

export const sortByMonthYear = (arr, key = "MonthYear") =>
  [...(arr || [])].sort(
    (a, b) => parseMonthYear(a[key]) - parseMonthYear(b[key]),
  );

export const MONTH_VALUES = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export const getPreviousMonthYear = (month, year) => {
  const idx = MONTH_VALUES.indexOf(month);
  if (idx === -1) return { month, year };
  if (idx === 0) {
    return {
      month: MONTH_VALUES[MONTH_VALUES.length - 1],
      year: String(Number(year) - 1),
    };
  }
  return { month: MONTH_VALUES[idx - 1], year };
};

export const CARD_CONFIG = {
  Onshore: {
    accent: "bg-gradient-to-br from-[#0060D0] to-[#00C6A2]",
    icon: "🏗️",
    valueColor: "text-white",
  },
  Service: {
    accent: "bg-gradient-to-br from-[#6d4cf5] to-[#3ba3ec]",
    icon: "🛠️",
    valueColor: "text-white",
  },
  "Advance on New Orders": {
    accent: "bg-gradient-to-br from-[#d97706] to-[#f59e0b]",
    icon: "📦",
    valueColor: "text-white",
  },
};

export const getCardConfig = (cardName) =>
  CARD_CONFIG[cardName] || {
    accent: "bg-gradient-to-br from-slate-500 to-slate-700",
    icon: "📊",
    valueColor: "text-white",
  };

export const defaultCards = [
  { cardName: "Onshore", cardValue: "—", monthYear: "" },
  { cardName: "Service", cardValue: "—", monthYear: "" },
  { cardName: "Advance on New Orders", cardValue: "—", monthYear: "" },
];

export const defaultData = {
  cards: defaultCards,
  chart1: [],
  chart2: [],
  chart2Prev: [],
  chart3: [],
  chart3Prev: [],
  chart4: [],
  chart5: [],
};

export const buildDashboardData = (items) => ({
  cards: [
    items?.card1?.[0] || { cardName: "Onshore", cardValue: "0" },
    items?.card2?.[0] || { cardName: "Service", cardValue: "0" },
    items?.card3?.[0] || { cardName: "Advance on New Orders", cardValue: "0" },
  ],
  chart1: items?.chart1 || [],
  chart2: items?.chart2 || [],
  chart3: items?.chart3 || [],
  chart4: items?.chart4 || [],
  chart5: items?.chart5 || [],
});
